(function ($, window) {
    if (window.mg === undefined)
        window.mg = {};

    if (window.mg.ui === undefined)
        window.mg.ui = {};

    var _ = window.mg;

    _.ui.showMore = {
        onClick: function (element, initialCount, onShowMore, onShowLess, $itemHolder, showLessType) {
            var $element = $(element);
            var itemHolderClass = $element.data('item-holder-class');
            var parentClass = $element.data('parent-class');

            if ($itemHolder === undefined)
                $itemHolder = parentClass ? $element.parents('.' + parentClass).find('.' + itemHolderClass) : $element.parents('.' + itemHolderClass); // If no specific parent is set, we assume the itemHolder is the parent

            var $hiddenItems = $itemHolder.find('.hide');
            var toggled = $itemHolder.attr('data-toggled');

            if (toggled !== undefined) {
                toggled = toggled == '1';
            }
            else {
                toggled = $hiddenItems.length == 0;
            }

            var props = {
                btnShowMore: $element,
                itemHolder: $itemHolder,
                hiddenItems: $hiddenItems,
                toggled: toggled,
                hideText: showLessType == 'less' ? mg.translations.ShowLess : mg.translations.HideTheList,
                additionalCount: 3000
            };

            if (!toggled) {
                // Show more
                if ($.isFunction(onShowMore)) {
                    onShowMore(props);
                }
                else {
                    var additionalCount = props.additionalCount; // Show the next batch of items
                    var $hiddenItems = props.hiddenItems;
                    var $revealItems = $hiddenItems.slice(0, additionalCount);
                    $revealItems.length && $revealItems.removeClass('hide');
                    var remainingCount = $hiddenItems.length - additionalCount;

                    if (remainingCount > 0) {
                        // Update the counter in the text
                        mg.ui.showMore.setShowMore(props, 'more', remainingCount);
                    }
                    else {
                        // Change to "Hide the list"
                        mg.ui.showMore.setShowMore(props, 'hide');
                    }
                }
            }
            else {
                // Show less
                if ($.isFunction(onShowLess)) {
                    onShowLess(props);
                }
                else {
                    var $allItems = props.itemHolder.find('> .favorite');
                    $allItems.slice(initialCount).addClass('hide'); // Hide all items with an index higher than initialCount
                    mg.ui.showMore.setShowMore(props, 'more', $allItems.length - initialCount);
                }
            }

            $itemHolder.attr('data-toggled', toggled ? 0 : 1); // Reverse the data-toggled attribute
        },
        setShowMore: function (props, identifier, count) {
            var $btnShowMore = props.btnShowMore;
            var text = props.hideText;
            var iconClassPlus = 'icon-plus';
            var iconClassMinus = 'icon-minus';
            var newClass = '';

            if (identifier === 'more') {
                text = mg.translations.ShowMore + (count !== undefined ? ' (' + count + ')' : '');
                newClass = iconClassPlus;
            }
            else
                newClass = iconClassMinus;

            $btnShowMore.find('.show-more-text').html(text);
            $btnShowMore.find('.show-more-icon .icon').removeClass(iconClassPlus + ' ' + iconClassMinus).addClass(newClass);
        },
        getToggled: function ($itemHolder) {
            var toggled = $itemHolder.attr('data-toggled');

            if (toggled !== undefined) {
                toggled = toggled == '1';
            }
            else {
                var $hiddenItems = this.getHiddenItems($itemHolder);
                toggled = $hiddenItems.length == 0;
            }

            return toggled;
        },
        getHiddenItems: function ($itemHolder) {
            return $itemHolder.find('.hide');
        }
    }
})($, window);
